<template>
    <div v-if="isAvailable">
        <b-overlay :show="isLoading" class="d-inline-block my-1" opacity="0.6" rounded spinner-small spinner-variant="primary">
            <b-btn class="btn-card-action btn-card-action-green my-1" @click="copyPurchase">Копировать</b-btn>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-copy-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        async copyPurchase() {
            this.isLoading = true;
            try {
                const purchaseId = await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].copyPurchase(this.purchase.id);
                if (purchaseId) {
                    await this.$router.push({ name: this.purchase.type === 'fl44' ? 'Fl44PurchaseEdit' : 'Fl44UnknownVolumePurchaseEdit', params: { id: purchaseId } });
                }
            } finally {
                this.isLoading = false;
            }
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.copy;
        }
    }
};
</script>
